import api from "./axios";
import type { Club } from "@/types";

export const getClubs = () => api.get<Club[]>("/clubs").then((r) => r.data);
export const getClub = (id: string) =>
  api.get<Club>(`/clubs/${id}`).then((r) => r.data);
export const createClub = (data: Partial<Club>) =>
  api.post<Club>("/clubs", data).then((r) => r.data);
export const updateClub = (id: string, data: Partial<Club>) =>
  api.patch<Club>(`/clubs/${id}`, data).then((r) => r.data);
export const deleteClub = (id: string) => api.delete(`/clubs/${id}`);
